'use strict';

var initCardSlideshow = function(slideshowEl) {
    let currentIndex = 1;
    const items = slideshowEl.querySelectorAll('.card-item');
    const totalItems = items.length;

    if (!totalItems) return;

    function showItem(index) {
        items.forEach((item, i) => {
            if (i === index - 1) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    showItem(currentIndex);

    slideshowEl.addEventListener('click', function(e) {
        if (e.target.classList.contains('next-btn')) {
            currentIndex = (currentIndex % totalItems) + 1;
            showItem(currentIndex);
        } else if (e.target.classList.contains('prev-btn')) {
            currentIndex = (currentIndex - 2 + totalItems) % totalItems + 1;
            showItem(currentIndex);
        }
    });
};

var init = function() {

    const cardLayouts = document.querySelectorAll('.images-card-layout');
    cardLayouts.forEach(function(slideshowEl) {
        initCardSlideshow(slideshowEl);
    });
    
};

module.exports = {
    init: init
};
